<template>
    <KRHPPaigutus>
        <template #pais>
            <v-row>
                <v-col>
                    <VoHoiatus class="ma-2"></VoHoiatus>
                    <h1 class="px-2">Dokumendid</h1>
                    <p class="px-2 text-textDark text-justify mt-3" v-if="lehePaiseTekst && lehePaiseTekstLuhendatud">
                        <VoKuvaRohkem :terveTekst="lehePaiseTekst" :luhendatudTekst="lehePaiseTekstLuhendatud">
                        </VoKuvaRohkem>
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="px-5">
                    <v-data-table class="rounded" :headers="pealkirjadeTabel.paised" show-expand single-expand
                        :items="[{ pealkiri: 'Ametniku lisatud dokumendid' }]">
                        <template v-slot:bottom><v-data-table v-if="laeb" :loading="laeb">
                                <template v-slot:bottom> </template>
                                <template v-slot:[`headers`]="{ }"></template>
                            </v-data-table> </template>
                        <template v-slot:[`headers`]="{ }"></template>
                        <template v-slot:[`item.pealkiri`]="{ value }">
                            <span class="pealkiri">{{ value }}</span>
                        </template>
                        <template #expanded-row="{ columns }">
                            <tr>
                                <td :colspan="columns.length">
                                    <v-data-table v-if="!laeb" :headers="ametnikuLisatudDokumendidTabel.paised"
                                        :items="ametnikuLisatudDokumendidTabel.elemendid"
                                        :items-per-page="ametnikuLisatudDokumendidTabel.lehePikkus"
                                        item-key="failiNimi">
                                        <template v-slot:[`item.failiId`]="{ value, item }">
                                            <v-btn color="primary" variant="text" size="x-large"
                                                icon="mdi-file-download-outline"
                                                @click="laadiAmetnikuDokumentAlla(value, item.failiNimi, true)"></v-btn>
                                        </template>
                                        <template v-slot:bottom> </template>
                                        <template v-slot:[`headers`]="{ }"></template>
                                    </v-data-table>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="px-5">
                    <v-data-table class="rounded" :headers="pealkirjadeTabel.paised" show-expand single-expand
                        :items="[{ pealkiri: 'Kirjalikud hoiatused' }]">
                        <template v-slot:bottom><v-data-table v-if="laeb" :loading="laeb">
                                <template v-slot:bottom> </template>
                                <template v-slot:[`headers`]="{ }"></template>
                            </v-data-table> </template>
                        <template v-slot:[`headers`]="{ }"></template>
                        <template v-slot:[`item.pealkiri`]="{ value }">
                            <span class="pealkiri">{{ value }}</span>
                        </template>
                        <template #expanded-row="{ columns }">
                            <tr>
                                <td :colspan="columns.length">
                                    <v-data-table :headers="kirjalikudHoiatusedTabel.paised"
                                        :items="kirjalikudHoiatusedTabel.elemendid"
                                        :items-per-page="kirjalikudHoiatusedTabel.lehePikkus" :loading="laeb"
                                        item-key="failiNimi">
                                        <template v-slot:[`item.failiId`]="{ value, item }">
                                            <v-btn color="primary" variant="text" size="x-large"
                                                icon="mdi-file-download-outline"
                                                @click="laadiHoiatuseDokumentAlla(value, item.failiNimi)"></v-btn>
                                        </template>
                                        <template v-slot:bottom> </template>
                                        <template v-slot:[`headers`]="{ }"></template>
                                    </v-data-table>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="px-5">
                    <v-data-table class="rounded" :headers="pealkirjadeTabel.paised" show-expand single-expand
                        :items="[{ pealkiri: 'Erakorralised ettekanded' }]">
                        <template v-slot:bottom><v-data-table v-if="laeb" :loading="laeb">
                                <template v-slot:bottom> </template>
                                <template v-slot:[`headers`]="{ }"></template>
                            </v-data-table> </template>
                        <template v-slot:[`headers`]="{ }"></template>
                        <template v-slot:[`item.pealkiri`]="{ value }">
                            <span class="pealkiri">{{ value }}</span>
                        </template>
                        <template #expanded-row="{ columns }">
                            <tr>
                                <td :colspan="columns.length">
                                    <v-data-table :headers="erakorralisedEttekannedTabel.paised"
                                        :items="erakorralisedEttekannedTabel.elemendid"
                                        :items-per-page="erakorralisedEttekannedTabel.lehePikkus" :loading="laeb"
                                        item-key="failiNimi">
                                        <template v-slot:[`item.failiId`]="{ value, item }">
                                            <v-btn color="primary" variant="text" size="x-large"
                                                icon="mdi-file-download-outline"
                                                @click="laadiEttekandeDokumentAlla(value, item.failiNimi)"></v-btn>
                                        </template>
                                        <template v-slot:bottom> </template>
                                        <template v-slot:[`headers`]="{ }"></template>
                                    </v-data-table>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </template>
    </KRHPPaigutus>
</template>

<style scoped>
.pealkiri {
    font-size: 20px !important;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import KRHPPaigutus from './uldine/KRHPPaigutus.vue';
import mixin from '@/core/mixins';
import { DokumendidTeenus } from '@/core/dokumendid-teenus';
import { Dokument } from '@/models/Dokument';

const _dokumendidTeenus = new DokumendidTeenus();

export default defineComponent({
    name: 'DokumendidLeht',
    components: { KRHPPaigutus },
    data() {
        return {
            laeb: false,
            lehePaiseTekst: `<p class="py-3">Siin näete järgmisi dokumente:</p>
<ul class="px-4">
    <li>ametniku lisatud dokumendid – dokumendid, mis on ametniku poolt lisatud (näiteks juhendid, töölehed, suunavad dokumendid, üldkasuliku töö ajakava, elektroonilise valve ajakava, Teie poolt ametnikule esitatud dokumendid, mis on skänneritud ning lisatud ja nii edasi);</li>
    <li>kirjalikud hoiatused – ametniku poolt kinnitatud kirjalik hoiatus. Kirjalik hoiatus on kriminaalhooldusaluse rikkumisele reageerimise viis;</li>
    <li>erakorralised ettekanded – ametniku poolt allkirjastatud erakorraline ettekanne. Erakorraline ettekanne on kriminaalhooldusaluse rikkumisele reageerimise viis. Erakorralise ettekande edastab ametnik kohtusse.</li>
</ul>
<p class="py-3">Ametniku lisatud dokumentide all näete dokumendi pealkirja, dokumendi lisamise kuupäeva ning faili. Faili ikoonile vajutades saate laadida antud faili Teie poolt kasutatavasse seadmesse (arvuti, tahvelarvuti, mobiiltelefon).</p>
<p class="py-3">Kirjalikud hoiatused on seotud Teie kriminaalhooldusele arvele tulemise alusega. Näiteks kui Teile on koostatud kirjalik hoiatus käitumiskontrolli raames, siis hoiatus kannab pealkirja „Käitumiskontroll“. Kriminaalhoolduse arvele tulemise aluseid võib olla samaaegselt rohkem kui üks. Kirjaliku hoiatuse kuupäev tähistab dokumendi kinnitamise kuupäeva. Faili ikoonile vajutades saate laadida antud faili Teie poolt kasutatavasse seadmesse (arvuti, tahvelarvuti, mobiiltelefon).</p>
<p class="py-3">Erakorralistes ettekannetes on kuvatud Teie kohta koostatud erakorralised ettekanded. Kõige ülemine erakorraline ettekanne on Teile viimasena koostatud erakorraline ettekanne. Erakorralise ettekande kuupäev tähistab dokumendi allkirjastamise kuupäeva. Faili ikoonile vajutades saate laadida antud faili Teie poolt kasutatavasse seadmesse (arvuti, tahvelarvuti, mobiiltelefon).</p>`,
            lehePaiseTekstLuhendatud: `<p class="py-3">Siin näete järgmisi dokumente:</p>
<ul class="px-4">
    <li>ametniku lisatud dokumendid – dokumendid, mis on ametniku poolt lisatud (näiteks juhendid, töölehed, suunavad dokumendid, üldkasuliku töö ajakava, elektroonilise valve ajakava, Teie poolt ametnikule esitatud dokumendid, mis on skänneritud ning lisatud ja nii edasi);</li>
    <li>kirjalikud hoiatused – ametniku poolt kinnitatud kirjalik hoiatus. Kirjalik hoiatus on kriminaalhooldusaluse rikkumisele reageerimise viis;</li>
    <li>erakorralised ettekanded – ametniku poolt allkirjastatud erakorraline ettekanne. Erakorraline ettekanne on kriminaalhooldusaluse rikkumisele reageerimise viis. Erakorralise ettekande edastab ametnik kohtusse.</li>
</ul>`,
            pealkirjadeTabel: {
                laiendatud: [],
                paised: [
                    {
                        title: '',
                        key: 'data-table-expand',
                        cellProps: {
                            class: 'bg-primary'
                        }
                    },
                    {
                        key: 'pealkiri',
                        cellProps: {
                            class: 'bg-primary pealkiri'
                        },
                    },
                ],

                elemendid: new Array<Dokument>(),
                lehePikkus: -1
            },
            ametnikuLisatudDokumendidTabel: {
                paised: [
                    {
                        key: 'failiId',
                        width: 60,
                        sortable: false,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-background'
                        },
                    },
                    {
                        title: 'Dokumendi pealkiri',
                        key: 'failiNimi',
                        width: 300,
                        sortable: false,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-background'
                        },
                    },
                    {
                        title: 'Kuupäev',
                        key: 'sisestatudAeg',
                        width: 180,
                        sortable: false,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-background'
                        },
                    },
                ],

                elemendid: new Array<Dokument>(),
                lehePikkus: -1
            },
            kirjalikudHoiatusedTabel: {
                paised: [
                    {
                        key: 'failiId',
                        width: 60,
                        sortable: false,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-background'
                        },
                    },
                    {
                        title: 'Hoiatus',
                        key: 'failiNimi',
                        width: 300,
                        sortable: false,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-background'
                        },
                    },
                    {
                        title: 'Kuupäev',
                        key: 'sisestatudAeg',
                        width: 180,
                        sortable: false,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-background'
                        },
                    },
                ],

                elemendid: new Array<Dokument>(),
                lehePikkus: -1
            },
            erakorralisedEttekannedTabel: {
                paised: [
                    {
                        key: 'failiId',
                        width: 60,
                        sortable: false,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-background'
                        },
                    },
                    {
                        title: 'Ettekanne',
                        key: 'failiNimi',
                        width: 300,
                        sortable: false,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-background'
                        },
                    },
                    {
                        title: 'Kuupäev',
                        key: 'kinnitamiseKp',
                        width: 180,
                        sortable: false,
                        headerProps: {
                            class: 'v-theme--VokTeema bg-background'
                        },
                    },
                ],

                elemendid: new Array<Dokument>(),
                lehePikkus: -1
            },
        }
    },
    mixins: [mixin],
    methods: {
        test() {
            return 'test';
        },
        minuDokumendid() {
            this.laeb = true;
            Promise.all([
                _dokumendidTeenus.minuAmetnikuLisatudDokumendid(),
                _dokumendidTeenus.minuKirjalikudHoiatused(),
                _dokumendidTeenus.minuErakorralisedEttekanned()
            ]).then(([dokumendid, hoiatused, ettekanned]) => {
                this.ametnikuLisatudDokumendidTabel.elemendid = dokumendid;
                this.kirjalikudHoiatusedTabel.elemendid = hoiatused;
                this.erakorralisedEttekannedTabel.elemendid = ettekanned;
            }).finally(() => {
                this.laeb = false;
            });
        },
        laadiAmetnikuDokumentAlla(failiId: number, failiNimi: string | undefined, onLaiendiga: boolean = false) {
            _dokumendidTeenus.laadiAmetnikuDokumentAlla(failiId).then((dokument) => {
                this.salvestaFail(failiNimi, onLaiendiga, dokument);
            })
        },
        laadiHoiatuseDokumentAlla(failiId: number, failiNimi: string | undefined, onLaiendiga: boolean = false) {
            _dokumendidTeenus.laadiHoiatuseDokumentAlla(failiId).then((dokument) => {
                this.salvestaFail(failiNimi, onLaiendiga, dokument);
            })
        },
        laadiEttekandeDokumentAlla(failiId: number, failiNimi: string | undefined, onLaiendiga: boolean = false) {
            _dokumendidTeenus.laadiEttekandeDokumentAlla(failiId).then((dokument) => {
                this.salvestaFail(failiNimi, onLaiendiga, dokument);
            });
        },
        salvestaFail(failiNimi: string | undefined, onLaiendiga: boolean, dokument: Blob) {
            let failiNimiLaiendiga = failiNimi as string;
            if (!onLaiendiga) {
                const failiLaiend = ".pdf";
                failiNimiLaiendiga = failiNimi ? failiNimi.toLowerCase().endsWith(failiLaiend) ? failiNimi : failiNimi + failiLaiend : "dokument.pdf";
            }
            const data = window.URL.createObjectURL(dokument);
            const link = document.createElement("a");
            link.href = data;
            link.download = failiNimiLaiendiga;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(data);
            }, 100);
        }
    },
    mounted() {
        this.minuDokumendid();
    }
});
</script>
